
<div>
  <t-row class="permissions-table-row">
    <t-column size="" class="permissions-table-row-header row-header-selector">All actions {{ `(${totalActionsCount})` }}</t-column>
    <t-column
        v-for="permittee in permissionsTablePermittees"
        :key="`all_actions_${permittee.client_id}`"
        size=""
        class="enable-all"
        :data-hover="`${permittee.client_id}`"
    >
      <row>
        <input
            :id="`enable_all_action_permissions_${permittee.client_id}`"
            type="checkbox"
            @input="toggleAllPermissionsFor(permittee)"
            :checked="allPermissionsEnabledFor(permittee)"
            :indeterminate.prop="somePermissionsEnabledFor(permittee)"
        >
        <label :for="`enable_all_action_permissions_${permittee.client_id}`">
          All
        </label>
      </row>
    </t-column>
    <t-column :class="`empty_cell`" v-for="index in remainingColumns" :key="`empty_header_${index}`" size="">
      <row>&nbsp;</row>
    </t-column>
  </t-row>
  <template v-for="actionGroup in actionGroups">
    <t-row v-if="actionGroup.actions.length > 0" :key="`${accordionId(actionGroup.label)}`" class="has-actions permissions-table-row">
      <t-column size="" class="permissions-table-row-header collapsed">
        <button class="toggle-group collapsed row-header-selector"
          data-toggle="collapse"
          @click="resetScrollTrigger()"
          :href="`#toggle_permissions_${accordionId(actionGroup.label)}`"
          :data-target="`#toggle_permissions_${accordionId(actionGroup.label)}`"
          :aria-controls="`#toggle_permissions_${accordionId(actionGroup.label)}`"
          aria-expanded="false"
        >
          <div class="header-text">{{ actionGroup.label }}</div>
          <small class="small">{{ 'action' | pluralize(actionGroup.actions.length) }}</small>
        </button>
      </t-column>
      <t-column
          v-for="permittee in permissionsTablePermittees"
          :key="`all_${actionGroup.label}_${permittee.client_id}`"
          size=""
      >
        <row>
          <input
              :id="`enable_all_${actionGroup.label}_permissions_${permittee.client_id}`"
              type="checkbox"
              @input="toggleAllPermissionsFor(permittee, {actionType: actionGroup.actions[0].action_type})"
              :checked="allPermissionsEnabledFor(permittee, {actionType: actionGroup.actions[0].action_type})"
              :indeterminate.prop="somePermissionsEnabledFor(permittee, {actionType: actionGroup.actions[0].action_type})"
          >
          <label :for="`enable_all_${actionGroup.label}_permissions_${permittee.client_id}`">
            Enable
          </label>
        </row>
      </t-column>
      <t-column :class="`empty_cell`" v-for="index in remainingColumns" :key="`empty_cell_${index}`" size="">
        <row>&nbsp;</row>
      </t-column>
    </t-row>
    <div v-if="actionGroup.actions.length > 0" :id="`toggle_permissions_${accordionId(actionGroup.label)}`" class="collapse" :key="`${accordionId(actionGroup.label)}-row`">
      <action-row
          v-for="action in actionGroup.actions"
          :key="action.client_id"
          :action="action"
          :remainingColumns="remainingColumns"
      ></action-row>
    </div>
  </template>
</div>
